import React from 'react'
import { occupationContext } from './context';

const useOccupation = () => {
  const {
    occupations,
    occupationOptions
  } = React.useContext(occupationContext);
  return {
    occupations,
    occupationOptions
  };
}

export { useOccupation }
